/**
 *
 * @param error
 * @param defaultMessage
 * @returns {*}
 */
import { ucFirst } from "./string";

// Some backend exceptions (e.g. a failed third-party API call) carry a
// JSON-formatted string as their message instead of plain text, so the raw
// blob would otherwise get dumped verbatim into the UI. Unwrap it to the
// nested human message when the shape allows, falling back to the raw
// string untouched.
function unwrapJsonMessage(message) {
  const trimmed = message.trim();

  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
    return message;
  }

  try {
    const parsed = JSON.parse(trimmed);
    return parsed?.error?.message || parsed?.message || message;
  } catch {
    return message;
  }
}

export function formatError(error, defaultMessage = "Error has occurred") {
  const errors = [];

  if (error && error.response && error.response.data) {
    const data = error.response.data;

    if (data.error && Array.isArray(data.error) && data.error.length) {
      let error = "";

      data.error.map((i) => {
        if (i.messages && i.messages.length) {
          const fieldName = ucFirst(i.field.replace("_", " "));

          i.messages.map((i) => {
            const multilines = i.split("\n");

            if (multilines.length > 1) {
              multilines.map((j) => {
                errors.push(j);
              });
            } else {
              errors.push(fieldName + " - " + i);
            }
          });
        }
      });

      return errors;
    }

    if (data.error && typeof data.error === "object" && data.error.message) {
      return [unwrapJsonMessage(data.error.message)];
    }

    if (data.message) {
      return [unwrapJsonMessage(data.message)];
    }
  } else if (error && error.message) {
    return [unwrapJsonMessage(error.message)];
  }

  return [defaultMessage];
}
